import { StepType } from '../../../interfaces/enums/step-type';
import BaseStep from './BaseStep';
import IAction from '@/interfaces/actions.interface';
import store from '@/store';

export default class EvaluateStep extends BaseStep {
	public stepType = StepType.EVALUATE;
	public readyToCompleteText =
		'If you have decided which ones to apply for, press below to mark this step as complete.';
	public actions: IAction[] = [
		{
			done: (): boolean => {
				return store.getters.getWishlistStudyCount() > 0;
			},
		},
		{
			done: (): boolean => {
				return store.getters.getHasFavouritesInIsApplyingState();
			},
		},
	];

	public feedbackGiven = false;
	public icon = 'lnr-compare';
	public heading = 'Evaluate';
	public description = 'Review your programmes to decide which ones to apply for';
}
